<main>
  @if (authenticationService.isImpersonating()) {
    <section>
      <button (click)="returnFromImpersonation()">
        <div class="link-with-icon">
          <i class="fa-solid fa-user-secret"></i>
          <span class="with-subtext" i18n="@@StopImpersonationButton">
            Stop Impersonating
            <p>{{ impersonatingEmail }}</p>
          </span>
        </div>
      </button>
    </section>
  }

  @for(item of menu; track item){
    <details #details class="menu-item" name="user-menu">
      <summary [class.mobile]="(mobile$ | async)">
        <i [title]="item.label" class="fa-solid" [ngClass]="'fa-' + item.icon"></i>
        <span>{{ item.label }}</span>
      </summary>
      
      <div class="details-backdrop" (click)="details.open = false"></div>

      <div class="foldout-menu">
        @for(child of item.children; track child){
          <ng-container>
            @if(child.route){
              <a
                (click)="details.open = false"
                routerLink="{{ child.route }}" 
                class="link-with-icon" 
                routerLinkActive="active">
                <i class="fa-solid" [ngClass]="'fa-' + child.icon"></i>
                <span>{{ child.label }}</span>
              </a>
            } @else if (child.action){
              <a
                (click)="details.open = false; child.action()"
                class="link-with-icon">
                <i class="fa-solid" [ngClass]="'fa-' + child.icon"></i>
                <span>{{ child.label }}</span>
              </a>
            }
        </ng-container>}
      </div>
    </details>}
</main>